module.exports = __webpack_public_path__ + "img/DAVID_CANNON_33-rs.cecd4349.jpg";